<script>
import baseInput from './baseInput'

export default {

    name: 'choice-input',

    mixins: [ baseInput ],

    props: {
        type: String,
        label: String,
        checked: Boolean,
        id: String,
        disabled: Boolean,
        readonly: Boolean,
        name: String,
    },

}
</script>

<template lang="html">
    <div class="engage-choice-input">
        <label class="custom-control custom-checkbox" :class="{'p-0 m-0' : !label}">

            <input
            v-if="checked"
            :type="type"
            :name="name"
            class="custom-control-input"
            v-model="internalValue"
            :disabled="disabled"
            :readonly="readonly"
            checked
            :required="required"
            >

            <input
            v-else
            :type="type"
            :name="name"
            class="custom-control-input"
            v-model="internalValue"
            :disabled="disabled"
            :readonly="readonly"
            :required="required"
            >

            <span class="custom-control-indicator engage-checkbox text-center" :class="{ 'radio' : type=='radio' }">
                <i v-if="internalValue == true" class="fas fa-check fa-xs"></i>
            </span>


            <span v-if="label" class="custom-control-description">
                {{ label }}
            </span>
        </label>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/forms/elements/customchoice.vue